<ng-container>
  <ng-content select="md-list-item"></ng-content>
</ng-container>
